// extracted by mini-css-extract-plugin
export default {"box":"projectWindow_box__qUQcQ"};